import { FormattedMessage } from 'gatsby-plugin-intl';
import pipe from 'ramda/es/pipe';
import React, { FC } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import DefaultIcon from 'images/default-profile-picture.svg';
import { useConstConfigs } from 'modules/Core';
import { useDeveloperQuery } from 'modules/Developer';
import { useHasTeammatesAccess } from 'modules/Developer/hooks';
import { logout } from 'modules/Session';
import { noop } from 'utils/js';

import { buildHeaderActions } from '../../utils';
import {
  ContainerMenu,
  Item,
  LoadingContainer,
  LoadingIcon,
  LoadingName,
  LoggedInAction,
  UserAvatar,
  UserName,
  useMenu,
} from './styles';

const LoggedInActions: FC = () => {
  const { openMenuAt, popperProps } = useMenu({ placement: 'bottom' });

  const { ENABLE_WIDGETS } = useConstConfigs();

  const canSeeWidgets = ENABLE_WIDGETS;

  const canSeeTeammates = useHasTeammatesAccess();

  const ITEMS = buildHeaderActions({ logout })
    .filter((item) => (canSeeWidgets ? true : item.href !== ROUTER_PATHS.WIDGETS))
    .filter((item) => (canSeeTeammates ? true : item.href !== ROUTER_PATHS.TEAMMATES));

  const { data, isLoading } = useDeveloperQuery();

  return isLoading ? (
    <LoadingContainer>
      <LoadingName />
      <LoadingIcon />
    </LoadingContainer>
  ) : (
    <LoggedInAction>
      <UserName onClick={(event): void => openMenuAt(event.target as Element, {})}>
        <FormattedMessage id="core.header.logged-in-actions.hi" values={{ userName: data?.name }} />
      </UserName>
      <UserAvatar alt="avatar" src={data?.photo} fallbackSrc={DefaultIcon} />
      <ContainerMenu popperProps={popperProps}>
        {({ closePopper }) =>
          ITEMS.map(({ onClick = noop, messageId, href }) => (
            <Item key={messageId} href={href} onClick={pipe(onClick, closePopper)} dataTestId={messageId}>
              <FormattedMessage id={messageId} />
            </Item>
          ))
        }
      </ContainerMenu>
    </LoggedInAction>
  );
};

export default LoggedInActions;
